import * as ShippingAddresses from './ShippingAddresses';

export default ShippingAddresses;
